

























import { defineComponent, computed, } from '@vue/composition-api'

export default defineComponent({

  props: {
    score: {
      type: Number,
      required: true,
    },
    round: {
      type: Number,
      required: true,
    },
    remainingTime: {
      type: Number,
      required: false,
    }
  },

  setup(props) {
    const countdownText = computed<string>(() => {
      if (props.remainingTime !== undefined) {
        let minutes: string | number = Math.floor(props.remainingTime / 60)
        let seconds: string | number = props.remainingTime % 60
        if (minutes < 10) {
          minutes = `0${minutes}`
        }
        if (seconds < 10) {
          seconds = `0${seconds}`
        }
        return `${minutes}:${seconds}`   
      } else {
        return ''
      }
    })

    return {
      countdownText,
    }
  }
})
